import { withPage } from '@/http';
var energyRequest = axios.create({
  baseURL: '/api/powermanage'
});
energyRequest.interceptors.request.use(withPage);
var Api = {
  // overview
  // 用電
  GetLastDoc: '/poweroverview/lastdoc',
  // GetAccPowerToday: '/poweroverview/accpowertoday', // 目前沒用到
  GetAccPowerThisMon: '/poweroverview/accpowerthismon',
  GetCo2ThisYear: '/poweroverview/co2thisyear',
  GetReRatioThisMon: '/poweroverview/reratiothismon',
  GetPowerChart: '/poweroverview/powerchart',
  // 今年各區辦公室總用電量
  GetOfficeTotalThisYear: '/poweroverview/totalpowerofofficesthisyear',
  // 綠電
  GetGreenPower: '/poweroverview/greenpowerdetail',
  // 發電用電
  GetPowerGenPowerUsage: '/poweroverview/powergenpowerusage',
  // management
  GetEnergyInfo: '/info',
  GetEnergyAllInfos: '/infos',
  CreateEnergyInfo: '/createinfo',
  UpdateEnergyInfo: '/updateinfo',
  DeleteEnergyInfo: '/deleteinfo'
};

// ------------------------ overview ------------------------
// ------- 用電 --------
export var getLastDocApi = function getLastDocApi(fieldName) {
  return energyRequest.post(Api.GetLastDoc, {
    fieldName: fieldName
  });
};

// export const getAccPowerTodayApi = (fieldName) =>
//   energyRequest.post(Api.GetAccPowerToday, { fieldName })

export var getAccPowerThisMonApi = function getAccPowerThisMonApi(fieldName) {
  return energyRequest.post(Api.GetAccPowerThisMon, {
    fieldName: fieldName
  });
};
export var getCo2ThisYearApi = function getCo2ThisYearApi(fieldName) {
  return energyRequest.post(Api.GetCo2ThisYear, {
    fieldName: fieldName
  });
};
export var getReRatioThisMonApi = function getReRatioThisMonApi(fieldName) {
  return energyRequest.post(Api.GetReRatioThisMon, {
    fieldName: fieldName
  });
};

/**
 *
 * @param {startDate} string '2023-02-08', '2023'
 * @param {endDate} string '2023-02-08', '2023'
 */
export var getPowerChartApi = function getPowerChartApi(_ref) {
  var fieldName = _ref.fieldName,
    startDate = _ref.startDate,
    endDate = _ref.endDate,
    isAll = _ref.isAll;
  return energyRequest.post(Api.GetPowerChart, {
    fieldName: fieldName,
    startDate: startDate,
    endDate: endDate,
    isAll: isAll
  });
};
export var getOfficeTotalThisYearApi = function getOfficeTotalThisYearApi() {
  return energyRequest.post(Api.GetOfficeTotalThisYear);
};

// ------- 綠電 --------
export var getGreenPowerApi = function getGreenPowerApi(fieldName) {
  return energyRequest.post(Api.GetGreenPower, {
    fieldName: fieldName
  });
};

// ------- 發電用電 --------
export var getPowerGenPowerUsageApi = function getPowerGenPowerUsageApi(_ref2) {
  var fieldName = _ref2.fieldName,
    date = _ref2.date;
  return energyRequest.post(Api.GetPowerGenPowerUsage, {
    fieldName: fieldName,
    date: date
  });
};

// ------------------------ management ------------------------
/**
 * 取得單一案場資訊
 * @param {string} fieldName
 */
export var getEnergyInfoApi = function getEnergyInfoApi(fieldName) {
  return energyRequest.post(Api.GetEnergyInfo, {
    fieldName: fieldName
  });
};

/**
 * 取得所有案場資訊
 */
export var getEnergyAllInfosApi = function getEnergyAllInfosApi() {
  return energyRequest.post(Api.GetEnergyAllInfos);
};

/**
 * 建立案場資訊
 * @param {string} fieldName
 * @param {array} pvSource [ { factoryId: '', factoryName: '' } ]
 * @param {array} meterMapping [ { meterId: '', meterName: '', materLocation: '', meterType: '' } ]
 * @param {object} detail {}
 * @param {array} otherPowerSource []
 * @param {array} files
 */
// <!> meterId 不用填 系統補上
export var createEnergyInfoApi = function createEnergyInfoApi(_ref3) {
  var fieldName = _ref3.fieldName,
    pvSource = _ref3.pvSource,
    meterMapping = _ref3.meterMapping,
    detail = _ref3.detail,
    otherPowerSource = _ref3.otherPowerSource,
    files = _ref3.files;
  return energyRequest.post(Api.CreateEnergyInfo, {
    fieldName: fieldName,
    pvSource: pvSource,
    meterMapping: meterMapping,
    detail: detail,
    otherPowerSource: otherPowerSource,
    files: files
  });
};

/**
 * 更新案場資訊
 * @param {string} id
 * @param {number} queue 2
 * @param {string} fieldName
 * @param {array} pvSource [ { factoryId: '', factoryName: '' } ]
 * @param {array} meterMapping [ { meterId: '', meterName: '', materLocation: '', meterType: '' } ]
 * @param {object} detail {}
 * @param {array} otherPowerSource []
 * @param {array} files
 */
export var updateEnergyInfoApi = function updateEnergyInfoApi(_ref4) {
  var id = _ref4.id,
    fieldName = _ref4.fieldName,
    operations = _ref4.operations;
  return energyRequest.put(Api.UpdateEnergyInfo, {
    id: id,
    fieldName: fieldName,
    operations: operations
  });
};

/**
 * 刪除案場資訊
 * @param {string} id
 * @param {string} fieldName
 */
export var deleteEnergyInfoApi = function deleteEnergyInfoApi(_ref5) {
  var id = _ref5.id,
    fieldName = _ref5.fieldName;
  return energyRequest.delete(Api.DeleteEnergyInfo, {
    data: {
      id: id,
      fieldName: fieldName
    }
  });
};